"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorSchema = exports.ResponseSchema = exports.BodySchema = exports.method = exports.path = exports.action = void 0;
exports.parseBody = parseBody;
exports.parseResponse = parseResponse;
exports.parseError = parseError;
const zod_1 = require("zod");
const common_1 = require("../../../../common");
const common_2 = require("../../../../common");
/** относительно `${config.http.webAuthUrl}` */
exports.action = 'user-token';
exports.path = 'user-token';
exports.method = common_1.HttpMethod.GET;
// #region Request
exports.BodySchema = zod_1.z.object({
  email: common_2.BasicEmail,
  password: common_2.BasicPassword,
  audience: common_2.BasicAudience
});
function parseBody(dto) {
  return exports.BodySchema.parse(dto);
}
// #endregion
// #region Response
exports.ResponseSchema = zod_1.z.object({
  id: zod_1.z.string().uuid(),
  slug: zod_1.z.string(),
  access: zod_1.z.string(),
  refresh: zod_1.z.string()
});
function parseResponse(dto) {
  return exports.ResponseSchema.parse(dto);
}
exports.ErrorSchema = zod_1.z.object({
  error: zod_1.z.string()
});
function parseError(dto) {
  return exports.ErrorSchema.parse(dto);
}
// #endregion
